// Behavior ported from coach-oj-landing.html, wired to the real backend.
// Design/markup/CSS are untouched; only the demo scheduler -> real bookings/Stripe,
// the FULL flag -> live capacity read, and a waitlist form were added.
/* eslint-disable */
import { I18N } from "./i18n";
import { quoteOfTheDay } from "./quotes";

const EXTRA = {
  en: {
    bk_name: "Your name", bk_email: "Email",
    bk_note: "A line about what you want to change (optional)",
    need_info: "Please add your name and a valid email.",
    wl_title: "Join the waitlist",
    wl_sub: "I'm at capacity right now — leave your details and you're first in line.",
    wl_confirm: "Join the waitlist", wl_done_h: "You're on the list",
    wl_done_p: "Thanks — I'll reach out the moment a spot opens.",
    err: "Something went wrong. Please try again.",
    redirect: "Taking you to secure checkout…",
  },
  fr: {
    bk_name: "Votre nom", bk_email: "E-mail",
    bk_note: "Quelques mots sur ce que vous voulez changer (optionnel)",
    need_info: "Ajoutez votre nom et un e-mail valide.",
    wl_title: "Rejoindre la liste d'attente",
    wl_sub: "Je suis complet pour l'instant — laissez vos coordonnées et vous serez prioritaire.",
    wl_confirm: "Rejoindre la liste", wl_done_h: "Vous êtes sur la liste",
    wl_done_p: "Merci — je vous contacte dès qu'une place se libère.",
    err: "Une erreur s'est produite. Réessayez.",
    redirect: "Redirection vers le paiement sécurisé…",
  },
  ar: {
    bk_name: "اسمك", bk_email: "البريد الإلكتروني",
    bk_note: "سطر عمّا تريد تغييره (اختياري)",
    need_info: "أضِف اسمك وبريدًا صحيحًا.",
    wl_title: "انضم إلى قائمة الانتظار",
    wl_sub: "أنا مكتمل حاليًا — اترك بياناتك لتكون أول من نتواصل معه.",
    wl_confirm: "انضم إلى القائمة", wl_done_h: "أنت على القائمة",
    wl_done_p: "شكرًا — سأتواصل فور توفّر مكان.",
    err: "حدث خطأ ما. حاول مجددًا.",
    redirect: "جارٍ تحويلك إلى الدفع الآمن…",
  },
};

const LOOKUP = {
  "Single Session": "coach_single",
  "30-Day Program": "coach_30day",
  "90-Day Program": "coach_90day",
};
const FREE_PLANS = ["Fit Call", "explore"];
const PLAN_BY_KEY = { coach_single: "Single Session", coach_30day: "30-Day Program", coach_90day: "90-Day Program" };

// [BUILD] Calendly handles scheduling; Stripe on this site still handles money.
const CALENDLY_USER = "coachoj";
const CALENDLY_EVENT = {
  "Fit Call": "free-discovery-call",
  "explore": "free-discovery-call",
  "Single Session": "single-session",
  "30-Day Program": "30-day-program",
  "90-Day Program": "90-day-program",
};
// Calendly's own light theme reads better than a dark tint — only the accent
// colour is overridden, so the buttons and selected dates stay on-brand.
// ---------------------------------------------------------------- analytics
// First-party, anonymous, and deliberately tiny.
//
// It sets no cookie, writes nothing to the visitor's device, and sends no
// identifier of any kind. That is what keeps this site free of a consent
// banner, and it is a property that has to be preserved every time this
// function is edited: the moment it starts sending something that links two
// visits to the same person, the site needs a banner and the privacy policy
// needs rewriting.
//
// It also never blocks anything. keepalive lets the request outlive the page
// during a redirect to checkout, and every failure is swallowed - an analytics
// call must never be able to stop somebody booking.
let trackedOnce = {};
function track(kind, plan) {
  try {
    // Fire each kind at most once per page view, so somebody idly clicking
    // between plans does not read as ten separate people considering them.
    const key = kind + ":" + (plan || "");
    if (trackedOnce[key]) return;
    trackedOnce[key] = true;

    let ref = "";
    try {
      // Host only, never the full referring URL - a full referrer can carry
      // search terms and query strings, which is exactly the sort of
      // accidental personal data this is designed not to collect.
      if (document.referrer) {
        const h = new URL(document.referrer).hostname;
        if (h && h !== window.location.hostname) ref = h;
      }
    } catch (e) {}

    fetch(apiBase + "/track", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        kind: kind,
        plan: plan || null,
        lang: typeof LANG === "string" ? LANG : null,
        ref_host: ref || null,
        device: window.innerWidth < 768 ? "mobile" : "desktop",
        path: (window.location.pathname || "/").slice(0, 120),
      }),
    }).catch(() => {});
  } catch (e) {}
}

const CALENDLY_THEME = "primary_color=1e7be5";

function calendlyUrl(plan) {
  const slug = CALENDLY_EVENT[plan] || CALENDLY_EVENT["Fit Call"];
  return `https://calendly.com/${CALENDLY_USER}/${slug}?hide_gdpr_banner=1&hide_event_type_details=1&${CALENDLY_THEME}`;
}

// [BUILD] The embed is a plain iframe, built here, rather than Calendly's
// widget.js. Their script has to load, then load its own stylesheet, then
// measure our container before it will paint anything — three chances to end
// up with an empty box and no error. These two parameters are the only thing
// widget.js actually adds to the URL, and postMessage still reaches us.
function calendlyEmbedUrl(plan, name, email) {
  let url = calendlyUrl(plan) + "&embed_type=Inline";
  try { url += "&embed_domain=" + encodeURIComponent(window.location.hostname); } catch (e) { /* ignore */ }
  if (name) url += "&name=" + encodeURIComponent(name);
  if (email) url += "&email=" + encodeURIComponent(email);
  return url;
}

// Set true by the first calendly.* postMessage; the watchdog below reads it.
let calendlyAlive = false;
let calendlyWatchdog = null;

// A private code, once the server has confirmed it. Only the code travels to
// checkout — the amount here is for display and is never trusted for payment.
let activeOffer = null;

const fmtMoney = (cents, currency) => {
  const v = (cents / 100).toFixed(2).replace(/\.00$/, "");
  return currency === "eur" ? v + " \u20AC" : "$" + v;
};
const validEmail = (e) => /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e);

export function initLanding(apiBase) {
  ["en", "fr", "ar"].forEach((l) => { if (I18N[l]) Object.assign(I18N[l], EXTRA[l]); });

  const $ = (id) => document.getElementById(id);
  let LANG = "en";

  // [BUILD] Quote of the day. Deterministic by UTC date: the same quote for
  // every visitor for the whole day, and no way to skip forward or back.
  const paintQuote = () => {
    const el = $("qotdText"), by = $("qotdBy");
    if (!el || !by) return;
    const q = quoteOfTheDay(LANG);
    // Arabic uses its own quotation marks; Latin scripts use curly doubles.
    const open = LANG === "ar" ? "\u00AB\u00A0" : "\u201C";
    const close = LANG === "ar" ? "\u00A0\u00BB" : "\u201D";
    el.textContent = open + q.text + close;
    by.textContent = q.author;
  };
  paintQuote();

  // The coach's real photos live in /assets (not yet uploaded). Until then,
  // hide any broken <img> so the styled frames stay clean (design unchanged).
  const hideIfBroken = (img) => { img.style.visibility = "hidden"; };
  document.querySelectorAll("img").forEach((img) => {
    if (img.complete && img.naturalWidth === 0) hideIfBroken(img);
    img.addEventListener("error", () => hideIfBroken(img));
    img.addEventListener("load", () => { if (img.naturalWidth > 0) img.style.visibility = "visible"; });
  });

  const YR = new Date().getFullYear();
  if ($("yr")) $("yr").textContent = YR;
  let FULL = false;

  // [BUILD] Auto currency + language by visitor country (client-side, no external call)
  const MONEY = {
    usd: { sym: (v) => "$" + v, p1: 59, p2: 169, p3: 439, e2: 42, e3: 37 },
    eur: { sym: (v) => v + " €", p1: 50, p2: 144, p3: 384, e2: 36, e3: 32 },
  };
  const PER = {
    en: { p1: "one 50-min session · {price}", p2: "4 sessions · {each} each", p3: "12 sessions · {each} each" },
    fr: { p1: "une séance de 50 min · {price}", p2: "4 séances · {each} l'unité", p3: "12 séances · {each} l'unité" },
    ar: { p1: "جلسة واحدة (50 دقيقة) · {price}", p2: "4 جلسات · {each} للجلسة", p3: "12 جلسة · {each} للجلسة" },
  };
  const EURO = ["FR","DE","ES","IT","NL","BE","PT","IE","AT","FI","GR","LU","SK","SI","EE","LV","LT","CY","MT","HR"];
  function detectLocale() {
    const list = (navigator.languages && navigator.languages.length) ? navigator.languages : [navigator.language || "en-US"];
    const primary = list[0] || "en-US";
    const lang = primary.split("-")[0].toLowerCase();
    let region = (primary.split("-")[1] || "").toUpperCase();
    if (!region) { for (const l of list) { const r = (l.split("-")[1] || "").toUpperCase(); if (r) { region = r; break; } } }
    const uiLang = lang === "fr" ? "fr" : lang === "ar" ? "ar" : "en";
    let currency = EURO.includes(region) ? "eur" : "usd";
    if (!region && lang === "fr") currency = "eur";
    return { uiLang, currency };
  }
  const LOC = detectLocale();
  let CURRENCY = LOC.currency;
  function applyPricing() {
    const m = MONEY[CURRENCY] || MONEY.usd; const per = PER[LANG] || PER.en;
    const setT = (sel, txt) => { const el = document.querySelector(sel); if (el) el.textContent = txt; };
    setT('[data-i18n="plan1_price"]', m.sym(m.p1));
    setT('[data-i18n="plan2_price"]', m.sym(m.p2));
    setT('[data-i18n="plan3_price"]', m.sym(m.p3));
    setT('[data-i18n="plan1_per"]', per.p1.replace("{price}", m.sym(m.p1)));
    setT('[data-i18n="plan2_per"]', per.p2.replace("{each}", m.sym(m.e2)));
    setT('[data-i18n="plan3_per"]', per.p3.replace("{each}", m.sym(m.e3)));
  }

  function applyI18nWithin(root) {
    const d = I18N[LANG];
    root.querySelectorAll("[data-i18n]").forEach((el) => { const k = el.getAttribute("data-i18n"); if (d[k] != null) el.textContent = d[k]; });
    root.querySelectorAll("[data-i18n-html]").forEach((el) => { const k = el.getAttribute("data-i18n-html"); if (d[k] != null) el.innerHTML = d[k]; });
  }

  function setLang(l) {
    const d = I18N[l]; if (!d) return; LANG = l;
    applyI18nWithin(document);
    applyPricing();
    const feat = document.querySelector(".card.feat"); if (feat && d.plan2_badge) feat.setAttribute("data-badge", d.plan2_badge);
    const r = $("rights"); if (d.footer_rights) r.textContent = d.footer_rights.replace("{yr}", YR);
    const rtl = l === "ar"; document.documentElement.lang = l; document.documentElement.dir = rtl ? "rtl" : "ltr"; document.body.classList.toggle("ar", rtl);
    document.querySelectorAll(".lang-opt").forEach((b) => b.classList.toggle("is-active", b.dataset.lang === l));
    applyCapacity();
    paintQuote();
  }
  document.querySelectorAll(".lang-opt").forEach((b) => b.addEventListener("click", () => setLang(b.dataset.lang)));

  // [BUILD] Calendly notifies the parent page by postMessage when a slot is booked.
  // Any calendly.* message also proves the embed is alive and painting, which
  // is the only reliable signal we get — the iframe is cross-origin, so we
  // cannot look inside it.
  const onCalendlyMessage = (e) => {
    if (!e.origin || e.origin.indexOf("calendly.com") === -1) return;
    if (!e.data || typeof e.data.event !== "string") return;
    if (e.data.event.indexOf("calendly.") !== 0) return;
    // The calendar painted. If a slow connection had already made us show the
    // "open in a new tab" link, take it away again — the real thing is here.
    if (!calendlyAlive) {
      calendlyAlive = true;
      track("calendar_shown");
      clearTimeout(calendlyWatchdog);
      const fb = $("bkCalFallback"), host = $("bkCal");
      if (fb) fb.hidden = true;
      if (host) host.style.display = "";
    }
    // Calendly reports how tall its content actually is. Following it keeps the
    // panel snug instead of leaving a slab of empty space under the calendar.
    if (e.data.event === "calendly.page_height") {
      const px = parseInt((e.data.payload || {}).height, 10);
      const host = $("bkCal");
      if (host && px > 0) {
        const h = Math.max(420, Math.min(px + 8, 780));
        host.style.height = h + "px";
        host.style.minHeight = h + "px";
      }
    }
    if (e.data.event !== "calendly.event_scheduled") return;
    onScheduled(e.data.payload || {});
  };
  window.addEventListener("message", onCalendlyMessage);

  const toastEl = $("toast"); let tT;
  function toast(m) { toastEl.textContent = m; toastEl.classList.add("show"); clearTimeout(tT); tT = setTimeout(() => toastEl.classList.remove("show"), 3200); }

  function applyCapacity() {
    document.body.classList.toggle("full", FULL);

  document.querySelectorAll(".js-book").forEach((a) => {
      if (!a.dataset.orig) a.dataset.orig = a.getAttribute("data-i18n") || "";
      if (FULL) a.textContent = I18N[LANG].waitlist_btn;
      else if (a.dataset.orig && I18N[LANG][a.dataset.orig]) a.textContent = I18N[LANG][a.dataset.orig];
    });
  }
  async function loadCapacity() {
    try { const r = await fetch(apiBase + "/settings/public"); const j = await r.json(); FULL = !j.accepting_clients; }
    catch (e) { FULL = false; }
    applyCapacity();
  }

  /* ---------- booking ---------- */
  const modal = $("bookModal"), bkBody = $("bkBody");
  const FORM_HTML = bkBody.innerHTML;
  let selPlan, P, C, NAME, EMAIL, NOTE;

  function planKeys() { const d = I18N[LANG]; return [["Fit Call", "Fit Call"], ["Single Session", d.plan1_name], ["30-Day Program", d.plan2_name], ["90-Day Program", d.plan3_name], ["explore", d.bk_explore]]; }
  function renderPlans() { P.innerHTML = ""; planKeys().forEach(([id, label]) => { const c = document.createElement("button"); c.className = "chip" + (id === selPlan ? " sel" : ""); c.textContent = label; c.onclick = () => {
      selPlan = id;
      track("plan_view", id);
      if (activeOffer && activeOffer.plan !== LOOKUP[id]) clearOffer();
      renderPlans();
    }; P.appendChild(c); }); }
  function upd() { C.disabled = !(NAME.value.trim() && validEmail(EMAIL.value.trim())); }

  // Turns Calendly's "a booking was made" message into a record on our side.
  // Calendly sends a reference, not the date and time — the backend resolves
  // that from Calendly's API when a token is configured.
  function onScheduled(payload) {
    const d = I18N[LANG];
    const name = (NAME.value || "").trim(), email = (EMAIL.value || "").trim(), note = (NOTE.value || "").trim();
    const eventUri = (payload && payload.event && payload.event.uri) || "";
    const inviteeUri = (payload && payload.invitee && payload.invitee.uri) || "";

    bkBody.innerHTML = '<div class="done"><div class="big">\u2026</div><h4>' + d.bk_working + '</h4></div>';

    const body = { plan: selPlan, name, email, note, event_uri: eventUri, invitee_uri: inviteeUri };

    if (FREE_PLANS.includes(selPlan)) {
      fetch(apiBase + "/bookings/calendly", {
        method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
      }).finally(() => {
        bkBody.innerHTML = '<div class="done"><div class="big">\u2713</div><h4>' + d.bk_done_h +
          '</h4><p>' + d.bk_done_cal + '</p></div>';
      });
      return;
    }

    // Paid: the slot is held in Calendly, now take the money.
    track("checkout_start", selPlan);
    fetch(apiBase + "/payments/checkout", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        lookup_key: LOOKUP[selPlan], origin_url: window.location.origin,
        name, email, note, currency: activeOffer ? activeOffer.currency : CURRENCY,
        date: "", slot: "", event_uri: eventUri, invitee_uri: inviteeUri,
        offer_code: activeOffer ? activeOffer.code : "",
      }),
    })
      .then((res) => {
        if (res.status === 403) { FULL = true; applyCapacity(); closeBooking(); toast(I18N[LANG].waitlist_toast); return null; }
        return res.json();
      })
      .then((data) => {
        if (!data) return;
        if (data.checkout_url) { toast(d.redirect); window.location.href = data.checkout_url; }
        else throw new Error("checkout");
      })
      .catch(() => {
        bkBody.innerHTML = '<div class="done"><div class="big">!</div><h4>' + d.bk_pay_later_h +
          '</h4><p>' + d.bk_pay_later_p + '</p></div>';
      });
  }

  // If the embed does not paint, never leave the visitor looking at an empty
  // box: show a plain link that opens the same booking page in a new tab.
  // hideBox: true when the embed definitely failed, false when it is merely
  // slow — in that case the panel stays, so a late arrival is still usable.
  function calendarFailed(hideBox) {
    clearTimeout(calendlyWatchdog);
    const d = I18N[LANG], fb = $("bkCalFallback");
    if (!fb) return;
    fb.hidden = false;
    fb.innerHTML = "";
    const p = document.createElement("p");
    p.textContent = d.bk_cal_fallback;
    const a = document.createElement("a");
    a.className = "btn btn-clay";
    a.style.marginTop = "12px";
    a.href = calendlyUrl(selPlan);
    a.target = "_blank";
    a.rel = "noopener";
    a.textContent = d.bk_cal_open;
    fb.appendChild(p); fb.appendChild(a);
    if (hideBox) { const host = $("bkCal"); if (host) host.style.display = "none"; }
  }

  function showCalendar() {
    $("bkStep1").hidden = true; $("bkStep2").hidden = false;
    const host = $("bkCal"); host.innerHTML = ""; host.style.display = "";
    host.style.height = ""; host.style.minHeight = "";   // back to the CSS default
    const fb = $("bkCalFallback"); if (fb) fb.hidden = true;

    calendlyAlive = false;
    clearTimeout(calendlyWatchdog);

    // A word while the iframe fetches, so the panel is never just a dark void.
    host.style.position = "relative";
    const wait = document.createElement("p");
    wait.textContent = (I18N[LANG] || {}).bk_cal_loading || "Loading the calendar…";
    wait.style.cssText = "position:absolute;top:50%;left:0;right:0;transform:translateY(-50%);" +
      "text-align:center;margin:0;padding:0 20px;color:#5a7088;font-size:.95rem";
    host.appendChild(wait);

    const frame = document.createElement("iframe");
    frame.src = calendlyEmbedUrl(selPlan, (NAME.value || "").trim(), (EMAIL.value || "").trim());
    frame.title = "Calendly";
    frame.frameBorder = "0";
    frame.setAttribute("allow", "camera; microphone; fullscreen");
    frame.style.position = "relative";
    frame.onload = () => { wait.remove(); };
    frame.onerror = () => calendarFailed(true);
    host.appendChild(frame);

    // The iframe is cross-origin, so "did it paint?" cannot be read from the
    // DOM — a blank Calendly page and a working one look identical from here.
    // Calendly posts a message as soon as its page renders; no message inside
    // twelve seconds means the visitor is staring at an empty box, so fall back
    // to a link that opens the same booking page in a new tab.
    calendlyWatchdog = setTimeout(() => {
      if (!calendlyAlive) calendarFailed(false);
    }, 12000);
  }

  // A link of the form coachoj.com/?code=ABCD2345 fills the box for them, so
  // the person you sent it to never has to type it.
  const codeFromUrl = (() => {
    try {
      const v = new URLSearchParams(window.location.search).get("code");
      return v ? v.trim().toUpperCase().slice(0, 16) : "";
    } catch (e) { return ""; }
  })();

  function clearOffer() {
    activeOffer = null;
    const msg = $("bkCodeMsg");
    if (msg) { msg.hidden = true; msg.textContent = ""; }
  }

  // A code is checked by the server before anything is shown. The price that
  // comes back is only for display; payment still quotes the code, never a
  // number from this page.
  function wireCodeField() {
    const toggle = $("bkCodeToggle"), row = $("bkCodeRow"), input = $("bkCode"),
          apply = $("bkCodeApply"), msg = $("bkCodeMsg");
    if (!toggle || !row || !input || !apply || !msg) return;

    const say = (text, good) => {
      msg.hidden = false;
      msg.textContent = text;
      msg.className = "bk-code-msg " + (good ? "is-good" : "is-bad");
    };

    toggle.addEventListener("click", () => {
      row.hidden = !row.hidden;
      if (!row.hidden) input.focus();
    });

    if (codeFromUrl) { row.hidden = false; input.value = codeFromUrl; }

    const check = () => {
      const d = I18N[LANG];
      const code = (input.value || "").trim().toUpperCase();
      if (!code) return;
      apply.disabled = true;
      track("code_try");
      fetch(apiBase + "/offers/" + encodeURIComponent(code))
        // 429 means the server is throttling us, NOT that the code is wrong.
        // Telling someone their valid code is invalid is the worst possible
        // lie to tell a person who already asked for a reduced rate.
        .then((r) => (r.status === 429 ? "slow" : r.ok ? r.json() : null))
        .then((offer) => {
          if (offer === "slow") { say(d.bk_code_slow || d.bk_code_bad, false); return; }
          if (!offer) { clearOffer(); say(d.bk_code_bad, false); return; }
          activeOffer = offer;
          if (PLAN_BY_KEY[offer.plan]) { selPlan = PLAN_BY_KEY[offer.plan]; renderPlans(); }
          say(
            d.bk_code_ok
              .replace("{plan}", offer.plan_label)
              .replace("{price}", fmtMoney(offer.amount, offer.currency)),
            true
          );
        })
        .catch(() => { clearOffer(); say(I18N[LANG].bk_code_bad, false); })
        .finally(() => { apply.disabled = false; });
    };

    apply.addEventListener("click", check);
    if (codeFromUrl && !activeOffer) check();
    input.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); check(); } });
    input.addEventListener("input", () => { if (activeOffer) clearOffer(); });
  }

  // ---- "ask about a reduced place" ----------------------------------------
  const applyModal = $("applyModal"), apBody = $("apBody");
  const AP_HTML = apBody ? apBody.innerHTML : "";

  function openApply() {
    track("apply_open");
    if (!applyModal) return;
    const d = I18N[LANG];
    apBody.innerHTML = AP_HTML;
    applyI18nWithin(apBody);
    const name = $("apName"), email = $("apEmail"), message = $("apMsg"), send = $("apSend");
    const upd = () => { send.disabled = !(name.value.trim() && validEmail(email.value.trim())); };
    [name, email].forEach((el) => el.addEventListener("input", upd));
    upd();
    send.addEventListener("click", () => {
      if (send.disabled) return;
      send.disabled = true;
      fetch(apiBase + "/applications", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: name.value.trim(), email: email.value.trim().toLowerCase(),
          message: message.value.trim(), plan: selPlan || "",
        }),
      })
        .then((r) => { if (!r.ok) throw new Error("apply"); })
        .then(() => {
          apBody.innerHTML = '<div class="done"><div class="big">\u2713</div><h4>' +
            d.ap_done_h + '</h4><p>' + d.ap_done_p + '</p></div>';
        })
        .catch(() => { send.disabled = false; toast(d.err); });
    });
    applyModal.classList.add("open");
    applyModal.setAttribute("aria-hidden", "false");
  }

  function closeApply() {
    if (!applyModal) return;
    applyModal.classList.remove("open");
    applyModal.setAttribute("aria-hidden", "true");
  }
  if ($("apClose")) $("apClose").addEventListener("click", closeApply);
  document.querySelectorAll(".js-apply").forEach((b) =>
    b.addEventListener("click", (e) => { e.preventDefault(); openApply(); })
  );

  function openBooking(plan) {
    selPlan = plan || "explore";
    track("book_open");
    track("plan_view", selPlan);
    bkBody.innerHTML = FORM_HTML;
    P = $("bkPlans"); C = $("bkConfirm");
    NAME = $("bkName"); EMAIL = $("bkEmail"); NOTE = $("bkNote");
    applyI18nWithin(bkBody);
    const d = I18N[LANG]; C.textContent = d.bk_confirm;
    renderPlans(); upd();
    clearOffer();
    wireCodeField();

    [NAME, EMAIL].forEach((el) => el.addEventListener("input", upd));
    C.addEventListener("click", () => {
      if (!NAME.value.trim() || !validEmail(EMAIL.value.trim())) { toast(d.need_info); return; }
      showCalendar();
    });
    $("bkBack").addEventListener("click", () => {
      clearTimeout(calendlyWatchdog);
      $("bkStep2").hidden = true; $("bkStep1").hidden = false; $("bkCal").innerHTML = "";
    });

    modal.classList.add("open"); modal.setAttribute("aria-hidden", "false");
  }

  function openWaitlist(plan) {
    const d = I18N[LANG];
    const label = plan && LOOKUP[plan] ? plan : "";
    bkBody.innerHTML =
      '<div class="wl-body">' +
      '<h4>' + d.wl_title + '</h4><p>' + d.wl_sub + '</p>' +
      '<div class="bk-contact">' +
      '<div class="bk-field"><label>' + d.bk_name + '</label><input id="wlName" type="text" autocomplete="name"></div>' +
      '<div class="bk-field"><label>' + d.bk_email + '</label><input id="wlEmail" type="email" autocomplete="email"></div>' +
      '</div><div class="sheet-foot"><button class="btn btn-clay" id="wlConfirm">' + d.wl_confirm + '</button></div></div>';
    const btn = $("wlConfirm");
    btn.addEventListener("click", async () => {
      const name = ($("wlName").value || "").trim(), email = ($("wlEmail").value || "").trim();
      if (!name || !validEmail(email)) { toast(d.need_info); return; }
      btn.disabled = true;
      try {
        const res = await fetch(apiBase + "/waitlist", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ name, email, plan: label }) });
        if (!res.ok) throw new Error("wl");
        bkBody.innerHTML = '<div class="done"><div class="big">\u2713</div><h4>' + d.wl_done_h + '</h4><p>' + d.wl_done_p + '</p></div>';
      } catch (e) { toast(d.err); btn.disabled = false; }
    });
    modal.classList.add("open"); modal.setAttribute("aria-hidden", "false");
  }

  function closeBooking() {
    clearTimeout(calendlyWatchdog);
    const host = $("bkCal"); if (host) host.innerHTML = "";
    modal.classList.remove("open"); modal.setAttribute("aria-hidden", "true");
  }
  $("bkClose").addEventListener("click", closeBooking);
  modal.addEventListener("click", (e) => { if (e.target === modal) closeBooking(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeBooking(); });
  document.querySelectorAll(".js-book").forEach((a) => a.addEventListener("click", (e) => { e.preventDefault(); if (FULL) openWaitlist(a.dataset.plan); else openBooking(a.dataset.plan); }));
  document.querySelectorAll(".js-wa").forEach((a) => a.addEventListener("click", (e) => { if (a.getAttribute("href").includes("0000000000")) { e.preventDefault(); toast(I18N[LANG].toast_wa); } }));
  const vp = $("vidPlaceholder"); if (vp) vp.addEventListener("click", () => (FULL ? openWaitlist("explore") : openBooking("explore")));

  /* ---------- reveal ---------- */
  const io = new IntersectionObserver((es) => { es.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); } }); }, { threshold: 0.12 });
  document.querySelectorAll(".reveal,.reveal-left,.reveal-right").forEach((el, i) => { el.style.transitionDelay = Math.min(i, 6) * 0.06 + "s"; io.observe(el); });

  /* ---------- scroll progress ---------- */
  const prog = $("progress");
  const onScroll = () => { const h = document.documentElement; prog.style.width = (h.scrollTop / (h.scrollHeight - h.clientHeight || 1)) * 100 + "%"; };
  if (prog) window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------- hero glow + parallax ---------- */
  const hero = $("hero");
  if (hero) {
    hero.addEventListener("pointermove", (e) => {
      const r = hero.getBoundingClientRect(); const x = ((e.clientX - r.left) / r.width) * 100, y = ((e.clientY - r.top) / r.height) * 100;
      hero.querySelectorAll("[data-depth]:not(.plus)").forEach((el) => { const dp = parseFloat(el.dataset.depth); el.style.transform = (el.classList.contains("hero-accent") ? "rotate(-5deg) " : "") + "translate(" + ((x - 50) / 50) * dp + "px," + ((y - 50) / 50) * dp + "px)"; });
    });
    hero.addEventListener("pointerleave", () => { hero.querySelectorAll("[data-depth]:not(.plus)").forEach((el) => { el.style.transform = el.classList.contains("hero-accent") ? "rotate(-5deg)" : ""; }); });
  }

  /* ---------- magnetic buttons ---------- */
  document.querySelectorAll(".magnetic").forEach((btn) => {
    btn.addEventListener("pointermove", (e) => { const r = btn.getBoundingClientRect(); btn.style.transform = "translate(" + (e.clientX - r.left - r.width / 2) * 0.25 + "px," + (e.clientY - r.top - r.height / 2) * 0.35 + "px)"; });
    btn.addEventListener("pointerleave", () => { btn.style.transform = ""; });
  });
  /* ---------- card tilt ---------- */
  document.querySelectorAll(".tilt").forEach((card) => {
    card.addEventListener("pointermove", (e) => { const r = card.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5; card.style.transform = "perspective(900px) rotateX(" + -py * 5 + "deg) rotateY(" + px * 5 + "deg) translateY(-4px)"; });
    card.addEventListener("pointerleave", () => { card.style.transform = ""; });
  });

  loadCapacity();
  setLang(LOC.uiLang);

  // Fired once here, at the end of setup, rather than anywhere earlier: LANG is
  // settled by setLang above, so the visit is recorded against the language the
  // visitor is actually reading rather than a default that has not resolved yet.
  track("visit");

  return () => { if (prog) window.removeEventListener("scroll", onScroll);
    clearTimeout(calendlyWatchdog);
    window.removeEventListener("message", onCalendlyMessage); };
}
